module.exports = __webpack_public_path__ + "bf01775c3af2e21ec62602e2ce06a36c.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/onboarding/teacher-owl.png
// module id = 311
// module chunks = 0